const searchSection = document.querySelector('.search-section');
const categoriesPopup = document.querySelector('.categories-popup');

if (searchSection) {
  const stickyBtn = searchSection.querySelector('.sticky-button');
  const categoriesPopupClose = searchSection.querySelector(
    '.categories-popup-close'
  );
  const categoriesPopupCloseBg = searchSection.querySelector(
    '.categories-popup-close-bg'
  );
  let nextSection = searchSection.nextElementSibling;

  while (nextSection && nextSection.tagName !== 'SECTION') {
    nextSection = nextSection.nextElementSibling;
  }

  window.addEventListener('scroll', () => {
    const scrollPosition = window.innerHeight + window.scrollY;
    const documentHeight = document.documentElement.offsetHeight;

    const threshold = documentHeight * 0.1;

    if (scrollPosition >= documentHeight - threshold) {
      stickyBtn.classList.add('is-hidden');
    } else {
      stickyBtn.classList.remove('is-hidden');
    }
  });

  if (nextSection) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyBtn.classList.add('is-hidden');
          } else {
            stickyBtn.classList.remove('is-hidden');
          }
        });
      },
      { threshold: 0, rootMargin: '0% 0% 10% 0%' }
    );

    observer.observe(nextSection);
  }

  stickyBtn.addEventListener('click', () => {
    categoriesPopup.classList.add('is-open');
    categoriesPopupCloseBg.classList.add('is-open');

    scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
    scrollLock.addScrollableSelector('.simplebar-content-wrapper');
  });

  categoriesPopupClose.addEventListener('click', () => {
    categoriesPopup.classList.remove('is-open');
    categoriesPopupCloseBg.classList.remove('is-open');

    scrollLock.enablePageScroll();
  });

  categoriesPopupCloseBg.addEventListener('click', () => {
    categoriesPopup.classList.remove('is-open');
    categoriesPopupCloseBg.classList.remove('is-open');

    scrollLock.enablePageScroll();
  });

  /*const categoriesCheckboxes = document.querySelectorAll(
    '.search-section__category input'
  );
  const categoriesMobileCheckboxes = document.querySelectorAll(
    '.categories-popup__category input'
  );

  function syncCheckboxes(sourceCheckboxes, targetCheckboxes) {
    sourceCheckboxes.forEach((sourceCheckbox, index) => {
      sourceCheckbox.addEventListener('change', () => {
        targetCheckboxes[index].checked = sourceCheckbox.checked;
        console.log(targetCheckboxes[index].checked, sourceCheckbox.checked);
      });
    });
  }

  syncCheckboxes(categoriesCheckboxes, categoriesMobileCheckboxes);

  syncCheckboxes(categoriesMobileCheckboxes, categoriesCheckboxes);*/
}
